import { Star, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GoogleReviewBadge({ rating = 5.0, count = 194, reviewUrl = "", variant = "default" }) {
  const openReview = () => {
    if (reviewUrl) window.open(reviewUrl, "_blank", "noopener,noreferrer");
  };

  if (variant === "compact") {
    return (
      <button onClick={openReview} className="inline-flex items-center gap-2 bg-card border border-border rounded-full px-4 py-2 hover:shadow-md transition-shadow group" data-testid="google-badge-compact">
        <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
        <div className="flex gap-0.5">{[...Array(5)].map((_,i)=><Star key={i} className="w-3.5 h-3.5 fill-accent text-accent" />)}</div>
        <span className="text-sm font-medium">{rating.toFixed(1)}</span>
        <span className="text-xs text-muted-foreground">({count})</span>
      </button>
    );
  }

  return (
    <div className="bg-card border border-border rounded-2xl p-6 flex flex-col sm:flex-row items-center gap-6" data-testid="google-badge-full">
      <div className="flex items-center gap-4">
        <svg viewBox="0 0 24 24" className="w-12 h-12 shrink-0"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
        <div>
          <div className="flex items-center gap-2">
            <span className="font-serif text-3xl">{rating.toFixed(1)}</span>
            <div className="flex gap-0.5">{[...Array(5)].map((_,i)=><Star key={i} className="w-5 h-5 fill-accent text-accent" />)}</div>
          </div>
          <div className="text-sm text-muted-foreground mt-1">Based on <strong className="text-foreground">{count}+</strong> Google reviews</div>
        </div>
      </div>
      <div className="flex-1" />
      <Button onClick={openReview} className="rounded-full bg-primary hover:bg-primary/90 h-11 px-6" data-testid="google-badge-cta">
        Rate us on Google <ExternalLink className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
